import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { ActionPanelContext, DetailsPanelContext } from '../../../../../../components/layout/rightPanels'
import { PANEL_TYPE } from '../../../utils/constant'
import { selectAssolement } from '../../assolement/assolementAction'

/**
 * Injecteur pour l'ouverture du panel de détail de culture
 */
export const openEtapeDetail = (WrappedComponent) => {
	const OpenEtapeDetailInjector = ({ selectAssolement, ...props }) => {
		const { openPanel: openPanelDetail } = React.useContext(DetailsPanelContext)
		const { closePanel: closePanelAction } = React.useContext(ActionPanelContext)

		const openEtapeDetail = (assolement, assolementEtapeId) => {
			closePanelAction()
			openPanelDetail()
			selectAssolement(assolement, PANEL_TYPE.ETAPE_DETAIL, assolementEtapeId)
		}

		return <WrappedComponent {...props} openEtapeDetail={React.useCallback(openEtapeDetail, [])} />
	}

	const actions = {
		selectAssolement
	}

	OpenEtapeDetailInjector.propTypes = {
		selectAssolement: PropTypes.func
	}

	return connect(undefined, actions)(OpenEtapeDetailInjector)
}
